import React from "react";
import Blog from "./Blog";
import Courses from "./Courses";
import "./css/LandingPage.css";
import Coding from "./img/coding.png";
import Journey from "./Journey";
import Why from "./Why";

function LandingPage() {
  return (
    <div className="main">
      <div className="main-content">
        <div className="main-content-moto">
          <p>Hi,</p>
          <p className="desc">
            We are on mission to provide the skills <br /> that college doesn't
            teach us.
            <br /> <br /> Be a real professional <br /> and Grow your Skills
            with us
          </p>
          <button>Enroll Now</button>
        </div>
        <div className="main-content-img">
          <img src={Coding} alt="img" />
        </div>
      </div>
      <div className="main-content-courses">
        <Courses />
      </div>
      <div className="main-content-why">
        <Why />
      </div>
      <div className="main-content-journey">
        <Journey />
      </div>
      <div className="main-content-blog">
        <Blog />
      </div>
    </div>
  );
}

export default LandingPage;
